export const makeHome = (index) => {
  const home = {
    associationId: null,
    baseReportName: null,
    index,
    metricGroupBy: null,
    metricType: null,
    reportPath: null,
    routeName: null,
    subId: null,
  }

  return home
}

export const copyHome = (homeOriginal, index) => {
  const home = {
    associationId: homeOriginal.associationId,
    baseReportName: homeOriginal.baseReportName,
    index: typeof index === 'number' ? index : homeOriginal.index,
    metricGroupBy: homeOriginal.metricGroupBy || null,
    metricType: homeOriginal.metricType || null,
    reportPath: homeOriginal.reportPath,
    routeName: homeOriginal.routeName,
    subId: homeOriginal.subId,
  }

  return home
}

export const copyHomes = (homes) => homes.reduce((newHomesArray, home, homeIndex) => {
  const homeCopy = copyHome(home, homeIndex)

  newHomesArray.push(homeCopy)

  return newHomesArray
}, [])

export const addHome = (homeToAdd, homesArray) => {
  const homes = copyHomes(homesArray)
  const newHome = copyHome(homeToAdd, homesArray.length)

  homes.push(newHome)

  return homes
}

export const editHome = (indexToEdit, homeEdits, homesArray) => {
  const homes = copyHomes(homesArray)
  const newHome = copyHome(homeEdits, indexToEdit)

  homes.splice(indexToEdit, 1, newHome)

  return homes
}

export const deleteHome = (indexToDelete, homesArray) => {
  const homes = copyHomes(homesArray)

  homes.splice(indexToDelete, 1)

  return homes.map((home, index) => {
    home.index = index
    return home
  })
}
